<template>
    <div class="modal modal-info modal-info-2 fade" :id="modalId" tabindex="-1" role="dialog" :aria-labelledby="modalId"
         aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>{{ modalTitle }}</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-inner">
                        <div class="row justify-content-center">
                            <div class="col-lg-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label"> Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="calendar.name"
                                    >
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group form-group-1">
                                    <label for="" class="form-label">Description</label>
                                    <textarea
                                        class="form-control height-2"
                                        v-model="calendar.description"
                                    ></textarea>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="calendar-color">
                                    <div
                                        class="form-group form-group-4"
                                        v-for="color in colors"
                                        :key="color.id"
                                    >
                                        <div
                                            class="form-check"
                                            :class="'form-check-c' + (color.id)"
                                        >
                                            <input
                                                class="form-check-input-checkbox"
                                                type="radio" id="home-office"
                                                v-model="calendar.color"
                                                :value="color.id"
                                            >
                                            <label class="form-check-label" for="home-office"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="btns-wrap">
                            <button class="btn btn--outline-primary" @click="closeModal">Cancel</button>
                            <button
                                class="btn btn--secondary"
                                @click="validateFields"
                            >Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import StyleHandler from "../../../../../resources/js/mixins/StyleHandler";
import CalendarService from "./services/CalendarService";
import ModalHandler from "../../../../../resources/js/mixins/ModalHandler";

export default {
    name: 'CalendarSettingsModal',
    mixins: [StyleHandler, ModalHandler],
    emits: ['update-calendar'],
    props: {
        calendarInfo: {
            type: Object,
            required: false,
        },
        modalTitle: String,
        modalId: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            calendar: {
                color: null,
                name: null,
                description: null,
            },
            isUpdate: false,
        }
    },
    methods: {
        validateFields() {
            if (!this.calendar.name || this.calendar.name.trim() === "") {
                this.$showErrorMessage('Please provide a calendar name')
            } else if (!this.calendar.color) {
                this.$showErrorMessage('Please provide a calendar color')
            } else {
                this.saveCalendarSettings()
            }
        },
        saveCalendarSettings() {
            if (this.isUpdate) {
                this.updateExistCalendar()
            } else {
                this.createNewCalendar()
            }
        },

        closeModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        async updateExistCalendar() {
            this.$showLoadingMessage()
           this.closeModal()
            try {
                await CalendarService.updateCalendar(this.calendarInfo.id, this.calendar);
                this.$showSuccessMessage('New Calendar was updated!')
                this.$emit('update-calendar');
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your calendar was not updated')
            }
        },

        async createNewCalendar() {
            this.$showLoadingMessage()
            this.closeModal()
            try {
                await CalendarService.createCalendar(this.calendar);
                this.$showSuccessMessage('New Calendar was created!')
                setTimeout(() => {
                    this.reloadPage()
                }, 500)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Your calendar was not created. Please try again')
            }
        },
        setData(calendarInfo) {
            for (const userKey of Object.keys(calendarInfo)) {
                if (this.calendar.hasOwnProperty(userKey)) {
                    this.calendar[userKey] = calendarInfo[userKey];
                }
            }
        },
    },
    mounted() {
        if (this.calendarInfo) {
            this.setData(this.calendarInfo)
            this.isUpdate = true
        }
    }

}

</script>


<style scoped>

</style>
